import Code from './Code';
export default Code;
//# sourceMappingURL=index.js.map